import React from "react";
import { TableCell } from "@material-ui/core";
import { DPEmployeeeReward, RewardStatus, rewardStatusDictionary, rewardReasonDictionary } from "Shared/types/Rewards";
import pretty from "Shared/pretty";
import { DPLineThroughTableRow } from "Components/DP";
import { RewardActions } from "./RewardActions/RewardActions";
import { RewardReason } from "generated/graphql";
import { ApprovalAction } from "Shared/types/ApprovalActions";

export interface EmployeeRewardsTableRowProps {
  employerId: string;
  employeeFullName: string;
  reward: DPEmployeeeReward
}

export const EmployeeRewardsTableRow = ({
  employerId,
  employeeFullName,
  reward,
}: EmployeeRewardsTableRowProps) => {
  const {
    createdAt,
    requester,
    totalAmountCents,
    status,
    approver,
    reason,
    rewardBudget: {
      expectedApprovers,
    },
  } = reward;

  const actions: ApprovalAction[] = [];

  const canApprove =
    status === RewardStatus.pendingApproval &&
    !!expectedApprovers?.filter(expectedApprover => expectedApprover.id === employerId).length;

  const canCancel =
    status === RewardStatus.pendingApproval &&
    requester.id === employerId;

  if (canApprove){
    actions.push(ApprovalAction.approve);
    actions.push(ApprovalAction.reject);
  } else if (canCancel) {
    actions.push(ApprovalAction.cancel);
  }

  const isRejected = status === RewardStatus.rejected;

  return (
    <DPLineThroughTableRow lineThrough={isRejected}>
      <TableCell>
        {pretty.date(createdAt, { withTime: true })}
      </TableCell>
      <TableCell>
        {pretty.fullName(requester.firstName!, requester.lastName!)}
      </TableCell>
      <TableCell>
        {pretty.dollar(totalAmountCents)}
      </TableCell>
      <TableCell>
        {rewardStatusDictionary[status as RewardStatus]}
      </TableCell>
      <TableCell>
        {approver && pretty.fullName(approver.firstName!, approver.lastName!)}
      </TableCell>
      <TableCell>
        {reason ? rewardReasonDictionary[reason as RewardReason] : ""}
      </TableCell>
      <TableCell align="center">
        {!!actions.length && (
          <RewardActions
            actions={actions}
            employeeFullName={employeeFullName}
            totalAmountCents={totalAmountCents}
            rewardId={reward.id}
            employerId={employerId}
          />
        )}
      </TableCell>
    </DPLineThroughTableRow>
  );
};
